import { render, staticRenderFns } from "./AnalyticsOverview.vue?vue&type=template&id=52be05f2&scoped=true&"
import script from "./AnalyticsOverview.vue?vue&type=script&lang=js&"
export * from "./AnalyticsOverview.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsOverview.vue?vue&type=style&index=0&id=52be05f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be05f2",
  null
  
)

export default component.exports